module.exports = "body {\n    text-align: center;\n}\n  \nh2 {\n    margin-top: 10px;\n    text-align: center;\n}\n  \n.chart_wrapper {\n    margin: 0px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/graphs/graphs.component.css
// module id = ./src/app/graphs/graphs.component.css
// module chunks = main